import { useEffect, useState } from "react";
import { Box, useMediaQuery, Skeleton } from "@mui/material";
import mission from "../../assets/mission.webp";
import mission1 from "../../assets/mission1.png";
import mission2 from "../../assets/mission2.png";
import { useTheme } from "@mui/material/styles";
import CustomText, { textStyles } from "../../components/CustomText";
import GetAppButton from "../../components/GetAppButton";
import circleframe from "../../assets/circleframe.png";
import { useTranslation } from "react-i18next";
import { useSocialLinks } from "../../components/fetchGetAppUrl";
import { BASE_URL } from "../../components/BASE_URL";
const MissionSection = () => {
  const { t,i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const [loading, setLoading] = useState(true);
  const [sectionTitle, setSectionTitle] = useState("");
  const [cardsData, setCardsData] = useState([]);
  const { links, } = useSocialLinks();

useEffect(() => {
  setLoading(true);
  fetch(
    `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=About_Mission`
  )
    .then((res) => res.json())
    .then((json) => {
      const section = json?.data?.[0];

      if (section?.items?.length) {
        const selectedItem =
          i18n.language === "es"
            ? section.items.find((item) => item.idx === 1)
            : section.items.find((item) => item.idx === 0);

        if (selectedItem) {
          setSectionTitle(selectedItem.title);

          const listItems = Array.isArray(selectedItem?.list)
            ? selectedItem.list
            : selectedItem?.list
              ? JSON.parse(selectedItem.list)
              : [];
          setCardsData([
            {
              icon: mission1,
              title: listItems[0]?.name || (i18n.language === "es" ? "Visión" : "Vision"),
              description: listItems[0]?.value || "",
            },
            {
              icon: mission2,
              title: listItems[1]?.name || (i18n.language === "es" ? "Misión" : "Mission"),
              description: listItems[1]?.value || "",
            },
          ]);
        }
      }
    })
    .catch(() => {
      setSectionTitle(t("mission_section_label"));
      setCardsData([]);
    })
    .finally(() => setLoading(false));
}, [i18n.language, t]); // 🔑 refresh when language changes


  return (
    <Box
      sx={{
        backgroundColor: "#0B2A47",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        flexWrap: "wrap",
        color: "#fff",
        px: { xs: 2, md: 8 },
        py: { xs: 6, md: 8 },
        gap: 2,
        alignItems: "center",
        marginTop: 10,
      }}
    >
      {/* Left Image Section */}
      <Box
        sx={{
          flex: isMobile ? "0 0 100%" : "0 0 50%",
          display: "flex",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <img
          src={mission}
          alt="Mission Illustration"
          style={{
            width: "100%",
            borderRadius: 2,
            objectFit: "contain",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
            display: "block",
          }}
        />
        <img
          src={circleframe}
          alt="Circle Frame"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
            userSelect: "none",
            width: "120px",
            height: "120px",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Right Content Section */}
      <Box
        sx={{
          flex: isMobile ? "0 0 100%" : "0 0 45%",
          display: "flex",
          flexDirection: "column",
          gap: 5,
          px: { xs: 0, md: 2 },
        }}
      >
        {loading ? (
          <Skeleton height={40} width="50%" />
        ) : (
          <CustomText
            style={{
              ...textStyles.h4,
              color: "#00F6FF",
              marginBottom: isMobile ? "0rem" : "0.1rem",
              marginTop: isMobile ? "0rem" : "0rem",
              fontSize: isMobile ? "40px" : "30px",
              textAlign: "left",
              paddingLeft: 10,
            }}
          >
            {sectionTitle}
          </CustomText>
        )}

        {loading
          ? [1, 2].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width="100%"
                height={100}
                sx={{ borderRadius: 2 }}
              />
            ))
          : cardsData.map(({ icon, title, description }, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  flexWrap: isMobile ? "wrap" : "nowrap",
                  gap: 2,
                }}
              >
                <img
                  src={icon}
                  alt={title}
                  style={{ width: "100px", height: "100px", objectFit: "contain" }}
                />
                <Box>
                  <CustomText
                    style={{
                      ...textStyles.h4,
                      color: "rgba(255, 255, 255, 0.9)",
                      marginBottom: isMobile ? "0rem" : "1rem",
                      marginTop: isMobile ? "0rem" : "0rem",
                      fontSize: isMobile ? "40px" : "30px",
                      textAlign: "left",
                      fontWeight: 500,
                    }}
                  >
                    {title}
                  </CustomText>
                  <CustomText
                    style={{
                      ...textStyles.body2,
                      color: "rgba(255, 255, 255, 0.9)",
                      textAlign: "left",
                      marginTop: "6px",
                      fontSize: "16px",
                    }}
                  >
                    {description}
                  </CustomText>
                </Box>
              </Box>
            ))}
      </Box>

      {/* Button below */}
      <Box
        sx={{
          flexBasis: "100%",
          display: "flex",
          justifyContent: "center",
          mt: 5,
          mb: 3,
        }}
      >
        <GetAppButton
          label={t("mission_section_button_label")}
          variant="primary"
          size="large"
        />
      </Box>
    </Box>
  );
};

export default MissionSection;






